import { useGlobalModules } from 'contexts';
import Expander from 'components/shared/expander/expander';
import getSpecificationRows from './getSpecificationRows';
import styles from './productSpecifications.module.scss';

const ProductSpecifications = ({ specs, size, ownOrder }) => {
  const { translations, settings } = useGlobalModules();
  const { specificationsTitle, sizeTitle } = translations.product;
  const rows = getSpecificationRows(specs, {
    size,
    sizeLabel: sizeTitle,
    order: ownOrder ? [] : settings?.product?.specificationsOrder,
  });

  if (!rows.length) return null;

  return (
    <Expander title={specificationsTitle}>
      <dl className={styles.list}>
        {rows.map(({ label, value }, i) => (
          <div key={`${label}-${i}`} className={styles.row}>
            <dt className={styles.label}>{label}</dt>
            <dd>{value}</dd>
          </div>
        ))}
      </dl>
    </Expander>
  );
};

export default ProductSpecifications;
